import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Spinner } from '@nextui-org/react';
import { useAuth } from '../../contexts/AuthContext';

interface Props {
  children: React.ReactNode;
}

/**
 * Route-Guard für den Admin-Bereich:
 * - AuthContext lädt noch → Spinner
 * - Nicht eingeloggt → /login (mit from-State wie ProtectedRoute)
 * - Eingeloggt, aber kein ADMIN → /
 */
const AdminRoute: React.FC<Props> = ({ children }) => {
  const { isAuthenticated, isLoading, user } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-[60vh]">
        <Spinner color="primary" size="lg" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if ((user as any)?.role !== 'ADMIN') {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default AdminRoute;
